import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import HomeHeroCarousel from "./HomeHeroCarousel";
import Button from "@components/button/Button";
import ChevronLarge from "@icons/ChevronLarge";
import useHeaderMargin from "@hooks/useHeaderMargin";
import { motion, useAnimationControls } from "framer-motion";
import useIsRTL from "@hooks/useIsRTL";
import MobileSwiper from "@components/swiper/MobileSwiper";
import useScreenDimensions from "@hooks/useScreenDimensions";
import { filterBgImgUrl } from "@utils/filtering";
import useScrollTo from "@hooks/useScrollTo";
import { useWindow } from "@hooks/useWindow";
import { useDocument } from "@hooks/useDocument";
const HomeHero = ({ homeHero }) => {
    var _a, _b;
    if (!homeHero || homeHero.length < 1) {
        return null;
    }
    const coverEl = useRef(null);
    const isMounted = useRef(false);
    const [selectedSlide, setSelectedSlide] = useState(homeHero[0]);
    const mainDiv = useRef();
    const { headerHeight } = useHeaderMargin();
    const textControls = useAnimationControls();
    const triangleControls = useAnimationControls();
    const { isRtl } = useIsRTL();
    const { width: screenWidth, height: screenHeight } = useScreenDimensions();
    const { scrollTo } = useScrollTo();
    const myWindow = useWindow();
    const myDocument = useDocument();
    const shouldRender = myWindow && myDocument;
    const gradientAngle = !isRtl ? 125 : 235;
    triangleControls.start(() => ({
        background: `linear-gradient(${gradientAngle}deg, rgb(255 255 255 / 0) 0%, rgba(255 255 255 / 0) 80%, #e81a3b 80%, #e81a3b 100%)`,
        transition: { delay: 0.3, duration: 0.5 }
    }));
    const onSlideChange = (index) => {
        // skip slide change on initial load
        if (!isMounted.current && index === 0) {
            isMounted.current = true;
            return;
        }
        setTimeout(() => {
            setSelectedSlide(homeHero[index]);
        }, 1000);
        textControls.start((i) => ({
            x: isRtl ? "125%" : "-125%",
            transition: { delay: i * 0.3, duration: 0.5 }
        }));
        triangleControls.start(() => ({
            background: `linear-gradient(${gradientAngle}deg, rgb(255 255 255 / 0) 0%, rgba(255 255 255 / 0) 0%, #e81a3b 0%, #e81a3b 100%)`,
            transition: { delay: 0.3, duration: 0.5 }
        }));
        setTimeout(() => {
            textControls.start((i) => ({
                x: "0",
                transition: { delay: i * 0.3, duration: 0.5 }
            }));
        }, 1300);
    };
    const onSlideDownClick = () => {
        var _a;
        const nextEl = (_a = mainDiv.current.nextElementSibling) !== null && _a !== void 0 ? _a : mainDiv.current.parentElement.nextElementSibling;
        if (nextEl) {
            scrollTo(nextEl);
        }
    };
    const getMaxCarouselWidth = () => {
        let items = homeHero.length;
        if (screenWidth < 1200 && items > 2) {
            return 500;
        }
        return items < 4 ? (items === 2 ? 210 * items : 180 * items) : 672;
    };
    const calculateImageWrapperWidth = () => {
        const position = isRtl ? "left" : "right";
        let width = 0;
        if (screenWidth > 1280 && screenHeight > 1310) {
            width = 100;
        }
        else if (screenWidth > 1310 && screenHeight > 1370) {
            width = screenHeight > 1000 ? 0 : 300;
        }
        else {
            return null;
        }
        return { [position]: `${width}px` };
    };
    const calculateTextSectionWIdth = () => {
        // width check
        if (screenWidth > 1800) {
            return 40;
        }
        // height check
        if (screenHeight < 1000 || screenHeight > 1440 || screenHeight > 1200) {
            return 40;
        }
        return 50;
    };
    return (_jsxs("div", { className: "home-hero", ref: mainDiv, children: [selectedSlide && (_jsx(_Fragment, { children: _jsxs("div", { className: "home-hero__cover hidden lg:flex", ref: coverEl, style: { paddingBottom: "15vw" }, children: [_jsxs("div", { className: "home-hero__left-section", children: [_jsx("div", { className: "home-hero__white-angled-bg", style: calculateImageWrapperWidth() }), _jsxs("div", { className: "home-hero__left-content-container", children: [_jsxs("div", { className: "home-hero__left-section-text", style: { width: `${calculateTextSectionWIdth()}vw` }, children: [_jsx(motion.div, { className: "home-hero__left-section-title", custom: 0.5, animate: textControls, children: (_a = selectedSlide.title) !== null && _a !== void 0 ? _a : "" }), _jsx(motion.div, { className: "home-hero__left-section-description", custom: 1, animate: textControls, children: (_b = selectedSlide.description) !== null && _b !== void 0 ? _b : "" })] }), _jsx(motion.div, { className: "home-hero__left-section-button", custom: 1.5, animate: textControls, children: selectedSlide.button && selectedSlide.button.title && selectedSlide.button.url && (_jsx(Button, { title: selectedSlide.button.title, link: selectedSlide.button.url, className: "whitespace-nowrap" })) })] }), homeHero.length > 1 && (_jsx("div", { className: "home-hero__left-section-carousel-section", style: { maxWidth: `${getMaxCarouselWidth()}px` }, children: _jsx(HomeHeroCarousel, { items: homeHero, onSlideChange: onSlideChange }) }))] }), _jsx("div", { className: "home-hero__right-section overflow-hidden", children: _jsx("div", { className: "home-hero__right-section-img", style: { backgroundImage: !!triangleControls && shouldRender ? `url('${filterBgImgUrl(selectedSlide.imageURL)}')` : "#e81a3b" } }) }), _jsx(motion.div, { className: "home-hero__red-angled-container", animate: triangleControls }), shouldRender && (_jsx("div", { className: "absolute left-0 right-0 z-[4] mx-auto w-10 animate-bounce", style: { bottom: `calc(20px + ${headerHeight}px + 15vw)` }, children: _jsx("div", { className: "hidden cursor-pointer justify-center lg:flex", onClick: () => onSlideDownClick(), children: _jsx(ChevronLarge, {}) }) }))] }) })), _jsx("div", { className: "flex max-w-full overflow-hidden lg:hidden", children: _jsx(MobileSwiper, { data: homeHero, loop: homeHero.length > 1, className: "home-hero-mobile", displayData: (selectedSlide) => {
                        var _a, _b;
                        return (_jsxs("div", { className: "home-hero__mobile-slide", children: [_jsx("div", { className: "home-hero__top-section", children: _jsxs("div", { className: "home-hero__top-section-text", children: [_jsxs("div", { className: "home-hero__left-section-text", children: [_jsx("div", { className: "home-hero__left-section-title", children: (_a = selectedSlide.title) !== null && _a !== void 0 ? _a : " " }), _jsx("div", { className: "home-hero__left-section-description", children: (_b = selectedSlide.description) !== null && _b !== void 0 ? _b : " " })] }), _jsx("div", { className: "home-hero__left-section-button", children: selectedSlide.button && selectedSlide.button.title && selectedSlide.button.url && (_jsx(Button, { title: selectedSlide.button.title, link: selectedSlide.button.url, className: "whitespace-nowrap line-clamp-1" })) })] }) }), _jsx("div", { className: "home-hero__mobile-img-wrapper", children: _jsx("img", { className: "home-hero__mobile-img", src: selectedSlide.mobileImageURL, alt: selectedSlide.imageAltText }) })] }));
                    } }) })] }));
};
export default HomeHero;
